import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lang]/industries/components/IndustryCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalVideoPlayer"] */ "/vercel/path0/components/ModalVideoPlayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/SplashButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui/background-beams.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicNextImage"] */ "/vercel/path0/node_modules/@prismicio/next/dist/PrismicNextImage.js");
;
import(/* webpackMode: "eager", webpackExports: ["PrismicPreviewClient"] */ "/vercel/path0/node_modules/@prismicio/next/dist/PrismicPreviewClient.js");
;
import(/* webpackMode: "eager", webpackExports: ["SliceSimulator"] */ "/vercel/path0/node_modules/@prismicio/next/dist/SliceSimulator.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
